// =============================================================
// VARIANCE — The Executive Command Center
// File      : App.tsx
// Location  : /home/Applications/variance/web/src/App.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : Main routing configuration with global HelpProvider.
// =============================================================

import { HelpProvider } from './components/HelpSystem';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Cockpit } from './pages/Cockpit';
import { Companies } from './pages/Companies';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';

import { Finance } from './pages/Finance';

import { HR } from './pages/HR';

import { SalesLaunchpad } from './pages/SalesLaunchpad';
import { SalesPipelines } from './pages/SalesPipelines';
import { SalesBookings } from './pages/SalesBookings';

import { Compliance } from './pages/Compliance';
import { ComplianceSetup } from './pages/ComplianceSetup';

import { Assets } from './pages/Assets';
import { Vendors } from './pages/Vendors';
import { Settings } from './pages/Settings';

import { Login } from './pages/Login';
import { Signup } from './pages/Signup';

import { AuthProvider } from './lib/AuthContext';

// Vendor Hub Imports
import { VendorsLaunchpad } from './pages/VendorsLaunchpad';
import { VendorList } from './pages/VendorList';

export default function App() {
    return (
    <HelpProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Auth Routes (No Layout) */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Main App Routes (Wrapped in Layout) */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  {/* 1. The Command Deck */}
                  <Route path="/" element={<Cockpit />} />
                  
                  {/* 2. Master Hierarchy */}
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/projects/:id" element={<ProjectDetail />} />
                  <Route path="/assets" element={<Assets />} />
                  <Route path="/vendors" element={<Vendors />} />
                  <Route path="/vendors" element={<VendorsLaunchpad />} />
                  <Route path="/vendors/:type" element={<VendorList />} />
                  
                  {/* 3. Revenue Engine */}
                  <Route path="/sales" element={<SalesLaunchpad />} />
                  <Route path="/sales/pipeline" element={<SalesPipelines />} />
                  <Route path="/sales/bookings" element={<SalesBookings />} />
                  
                  {/* 4. Governance & Compliance */}
                  <Route path="/compliance" element={<Compliance />} />
                  <Route path="/compliance/setup" element={<ComplianceSetup />} />
                  
                  {/* 5. Other Modules */}
                  <Route path="/reports" element={<Placeholder title="Reports" />} />
                  <Route path="/settings" element={<Settings />} />

                  {/* 6. Finance Modules */}
                  <Route path="/finance" element={<Finance />} />

                  {/* 7. HR Modules */}
                  <Route path="/hr" element={<HR />} />

                </Routes>
              </Layout>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </HelpProvider>
  );
}

// Inline Placeholder Component for missing modules
const Placeholder = ({ title }: { title: string }) => (
  <div className="p-10 text-white">Module {title} coming soon.</div>
);
